import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconTrashCan: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        opacity="0.4"
        d="M16.3691 7.90705C16.3691 7.96371 15.925 13.581 15.6713 15.9451C15.5125 17.3959 14.5772 18.2759 13.1743 18.3009C12.0964 18.325 11.0412 18.3333 10.003 18.3333C8.90076 18.3333 7.82284 18.325 6.77654 18.3009C5.42064 18.2684 4.48456 17.3709 4.33381 15.9451C4.07284 13.5727 3.63682 7.96371 3.62871 7.90705C3.62061 7.73622 3.67572 7.57373 3.78756 7.44206C3.89778 7.3204 4.05663 7.24707 4.22359 7.24707H15.7824C15.9485 7.24707 16.0993 7.3204 16.2184 7.44206C16.3294 7.57373 16.3854 7.73622 16.3691 7.90705Z"
        fill={props.fill}
      />
      <path
        d="M17.5 4.9808C17.5 4.63831 17.2301 4.36999 16.9059 4.36999H14.4762C13.9818 4.36999 13.5522 4.01833 13.442 3.52252L13.3059 2.91504C13.1154 2.1809 12.4581 1.66675 11.7206 1.66675H8.2802C7.53458 1.66675 6.88378 2.1809 6.68603 2.95504L6.55879 3.52335C6.44775 4.01833 6.01821 4.36999 5.52464 4.36999H3.09488C2.76988 4.36999 2.5 4.63831 2.5 4.9808V5.29745C2.5 5.63161 2.76988 5.90827 3.09488 5.90827H16.9059C17.2301 5.90827 17.5 5.63161 17.5 5.29745V4.9808Z"
        fill={props.fill}
      />
    </Icon>
  );
};

export default IconTrashCan;
